import { resetGameState, setState } from '@/actions';
import { toggleAdditionalGame } from '@/actions/additionalGame/additionalGame';
import {
  setCouponNumbers,
  toggleCouponNumber,
} from '@/actions/couponNumbers/couponNumbers';
import { setCurrentCouponId } from '@/actions/currentCouponIndex/currentCouponId';
import { setCurrentStep } from '@/actions/currentStep/currentStep';
import { setDrawDays } from '@/actions/drawDays/drawDays';
import { setDrawNumber } from '@/actions/drawNumber/drawNumber';
import { setDrawRate } from '@/actions/drawRate/drawRate';
import {
  setGameFormSubsidiary,
  setGameFormVariant,
} from '@/actions/gameForm/gameForm';
import { setPlayNumber } from '@/actions/playNumber/playNumber';
import { toggleWeeklySubscription } from '@/actions/weeklySubscription/weeklySubscription';
import { setWeeksNumber } from '@/actions/weeksNumber/weeksNumber';
import Game from '@/components/Game';
import { GameProps } from '@/components/Gameinterfaces';
import { AppState } from '@/reducers';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState, ownProps: GameProps) => {
  const ownState = state.games[ownProps.id];
  return {
    crossedNumbers: ownState.couponGroup,
    selectedPlayNumber: ownState.selectedPlayNumber,
    selectedDrawDays: ownState.selectedDrawDays,
    selectedWeeksNumber: ownState.selectedWeeksNumber,
    selectedWeeklySubscription: ownState.selectedWeeklySubscription,
    selectedDrawNumber: ownState.selectedDrawNumber,
    selectedDrawRate: ownState.selectedDrawRate,
    selectedAdditionalGames: ownState.selectedAdditionalGames,
    currentStep: ownState.currentStep,
    currentCouponId: ownState.currentCouponId,
    stateGames: state.games,
    allState: state,
    subsidiary: state.gameForm?.subsidiary,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCouponNumberClick: (game, coupon, group, value) => {
      dispatch(toggleCouponNumber(game, coupon, group, value));
    },
    onPlayNumbersUpdate: (game, values) => {
      dispatch(setPlayNumber(game, values));
    },
    onDrawDaysUpdate: (game, days) => {
      dispatch(setDrawDays(game, days));
    },
    onWeeksNumberUpdate: (game, weeksNumber) => {
      dispatch(setWeeksNumber(game, weeksNumber));
    },
    onWeeklySubscriptionUpdate: (game) => {
      dispatch(toggleWeeklySubscription(game));
    },
    onDrawNumberUpdate: (game, drawNumber) => {
      dispatch(setDrawNumber(game, drawNumber));
    },
    onDrawRateUpdate: (game, drawNumber) => {
      dispatch(setDrawRate(game, drawNumber));
    },
    onCouponUpdate: (game, coupon, group, values) => {
      dispatch(setCouponNumbers(game, coupon, group, values));
    },
    onAdditionalGameToggle: (game, id) => {
      dispatch(toggleAdditionalGame(game, id));
    },
    onCurrentStepUpdate: (game, value) => {
      dispatch(setCurrentStep(game, value));
    },
    onCurrentCouponIdUpdate: (game, currentCouponId) => {
      dispatch(setCurrentCouponId(game, currentCouponId));
    },
    onChangeFormVariant: (variant) => {
      dispatch(setGameFormVariant(variant));
    },
    onInitState: (state) => {
      dispatch(setState(state));
    },
    onResetGameState: (gameId) => {
      dispatch(resetGameState(gameId));
    },
    onSubsidiaryUpdate: (key) => {
      dispatch(setGameFormSubsidiary(key));
    },
  };
};

const GameContainer = connect(mapStateToProps, mapDispatchToProps)(Game);
export default GameContainer;
